import Alpine from "alpinejs";
import persist from "@alpinejs/persist";
import Slider from "./Slider";
import variantPicker from "./variantPicker";
import intersect from "@alpinejs/intersect";
import sticky from "alpinejs-sticky";
import quotationRequest from "./quotationRequest";
import search from "./search";

Alpine.plugin(sticky);
Alpine.plugin(intersect);

Alpine.data("Slider", Slider);
Alpine.data("variantPicker", variantPicker);
Alpine.data("quotationRequest", quotationRequest);
Alpine.data("search", search);

function initHeader() {
  // Elements
  if (document.body.classList.contains("home")) {
    const body = document.querySelector("body");

    if (window.pageYOffset > 10) {
      body.classList.remove("intro");
    } else {
      body.classList.add("intro");
    }
  }

  setMenuBorder();
}

function setMenuBorder() {
  const header = document.querySelector("#header");

  if (window.pageYOffset > 10) {
    header.classList.add("border-magenta-25");
    header.classList.remove("border-transparent");
  } else {
    header.classList.add("border-transparent");
    header.classList.remove("border-magenta-25");
  }
}

window.addEventListener("scroll", function () {
  initHeader();
});

document.addEventListener("DOMContentLoaded", function () {
  initHeader();
});

window.addEventListener("resize", function () {
  initHeader();
});

/**
 * Slider module
 */

const debounce = (func, wait, immediate = true) => {
  let timeout;
  return () => {
    const context = this;
    const args = arguments;
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    }, wait);
    if (callNow) func.apply(context, args);
  };
};

/**
 * Append the child element and wait for the parent's
 * dimensions to be recalculated
 * See https://stackoverflow.com/a/66172042/11784757
 */
const appendChildAwaitLayout = (parent, element) => {
  return new Promise((resolve, _) => {
    const resizeObserver = new ResizeObserver((entries, observer) => {
      observer.disconnect();
      resolve(entries);
    });
    resizeObserver.observe(element);
    parent.appendChild(element);
  });
};

document.addEventListener("alpine:init", () => {
  Alpine.data(
    "Marquee",
    ({ speed = 1, spaceX = 0, dynamicWidthElements = false }) => ({
      dynamicWidthElements,
      async init() {
        if (this.dynamicWidthElements) {
          const images = this.$el.querySelectorAll("img");
          // If there are any images, make sure they are loaded before
          // we start cloning them, since their width might be dynamically
          // calculated
          if (images) {
            await Promise.all(
              Array.from(images).map((image) => {
                return new Promise((resolve, _) => {
                  if (image.complete) {
                    resolve();
                  } else {
                    image.addEventListener("load", () => {
                      resolve();
                    });
                  }
                });
              })
            );
          }
        }

        // Store the original element so we can restore it on screen resize later
        this.originalElement = this.$el.cloneNode(true);
        const originalWidth = this.$el.scrollWidth + spaceX * 4;
        // Required for the marquee scroll animation
        // to loop smoothly without jumping
        this.$el.style.setProperty("--marquee-width", originalWidth + "px");
        this.$el.style.setProperty(
          "--marquee-time",
          ((1 / speed) * originalWidth) / 100 + "s"
        );
        this.resize();
        // Make sure the resize function can only be called once every 100ms
        // Not strictly necessary but stops lag when resizing window a bit
        window.addEventListener(
          "resize",
          debounce(this.resize.bind(this), 100)
        );
      },
      async resize() {
        // Reset to original number of elements
        this.$el.innerHTML = this.originalElement.innerHTML;

        // Keep cloning elements until marquee starts to overflow
        let i = 0;
        while (this.$el.scrollWidth <= this.$el.clientWidth) {
          if (this.dynamicWidthElements) {
            // If we don't give this.$el time to recalculate its dimensions
            // when adding child nodes, the scrollWidth and clientWidth won't
            // change, thus resulting in this while loop looping forever
            await appendChildAwaitLayout(
              this.$el,
              this.originalElement.children[i].cloneNode(true)
            );
          } else {
            this.$el.appendChild(
              this.originalElement.children[i].cloneNode(true)
            );
          }
          i += 1;
          i = i % this.originalElement.childElementCount;
        }

        // Add another (original element count) of clones so the animation
        // has enough elements off-screen to scroll into view
        let j = 0;
        while (j < this.originalElement.childElementCount) {
          this.$el.appendChild(
            this.originalElement.children[i].cloneNode(true)
          );
          j += 1;
          i += 1;
          i = i % this.originalElement.childElementCount;
        }
      },
    })
  );
});

window.Alpine = Alpine;
Alpine.plugin(persist);

Alpine.start();

let Grebify = {
  updateQuantity(group, qty) {
    // Get cart
    fetch("/cart.js")
      .then((response) => response.text())
      .then((cartData) => {
        const cart = JSON.parse(cartData);
        let data = {};

        cart.items.forEach((item) => {
          if (item.properties.Grupp == group) {
            data[item.key] = qty;
          }
        });

        fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: data }),
        })
          .then((response) => response.json())
          .then((data) => {
            // fire javascript event on window
            window.dispatchEvent(new Event("cart-updated"));
          })
          .catch((error) => {
            console.error("Error:", error);
          });
        //}
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  updateLineQuantity(line, qty) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ quantity: qty, line: line }),
    })
      .then((response) => response.json())
      .then((data) => {
        // fire javascript event on window
        window.dispatchEvent(new Event("cart-updated"));
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },

  noScroll(active = true) {
    const body = document.querySelector("body");
    if (active) {
      body.classList.remove("no-scroll");
    } else {
      body.classList.add("no-scroll");
    }
  },

  isValidLuhn(pnr) {
    var number;
    var checksum = 0;
    for (var i = pnr.length - 1; i >= 0; i--) {
      number = parseInt(pnr.charAt(i));
      if (i % 2 == 1) {
        checksum += number;
      } else {
        checksum += number * 2 > 9 ? number * 2 - 9 : number * 2;
      }
    }

    return checksum % 10 == 0;
  },

  isValidNorwegianPersonalNumber(number) {
    if (!/^\d{11}$/.test(number)) return false;

    const day = parseInt(number.substr(0, 2), 10);
    const month = parseInt(number.substr(2, 2), 10);
    const year = parseInt(number.substr(4, 2), 10);
    const individualNumber = parseInt(number.substr(6, 3), 10);

    if (day < 1 || day > 31) return false;
    if (month < 1 || month > 12) return false;
    if (year < 0 || year > 99) return false;
    if (individualNumber < 0 || individualNumber > 999) return false;

    return true;
  },

  isValidNorwegianOrganizationNumber(number) {
    if (!/^\d{9}$/.test(number)) return false;

    // Check if the input is a valid Norwegian organization number, based on what i found on brreg.no
    const weights = [3, 2, 7, 6, 5, 4, 3, 2];
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      sum += parseInt(number.charAt(i), 10) * weights[i];
    }

    const remainder = sum % 11;
    const checkDigit = remainder !== 0 ? 11 - remainder : 0;

    return parseInt(number.charAt(8), 10) === checkDigit;
  },

  cleanDigitString(digitString) {
    return digitString.replace(/\D/g, "");
  },

  validateOrganisationNumber(orgnr) {
    var orgnumber = this.cleanDigitString(orgnr);
    var isSwedishMarket = window.location.href.includes("goody.se");
    var isNorwegianMarket = window.location.href.includes("goodyprofil.no");

    if (isSwedishMarket) {
      if (
        orgnumber.length == 0 ||
        orgnumber.length < 10 ||
        orgnumber.length > 12 ||
        orgnumber.length == 11
      ) {
        return false;
      } else {
        return this.isValidLuhn(orgnumber);
      }
    }

    if (isNorwegianMarket) {
      if (orgnumber.length !== 9 && orgnumber.length !== 11) {
        return false;
      } else {
        if (orgnumber.length === 9) {
          return this.isValidNorwegianOrganizationNumber(orgnumber);
        } else if (orgnumber.length === 11) {
          return this.isValidNorwegianPersonalNumber(orgnumber);
        } else {
          return false;
        }
      }
    }
  },
};

window.Grebify = Grebify;
